<template lang="html">
  <div>
    <div class="row">
      <div class="col-xs-2">
        <pl-input
          class="w-100"
          v-model="user_search"
          placeholder="Search by name"
          @keyup.enter="filters"
        />
      </div>
      <div class="col-xs-2">
        <pl-input
          class="w-100"
          v-model="email_search"
          placeholder="Search by emails"
          @keyup.enter="filters"
        />
      </div>
      <div class="subjects col-xs-2">
        <multiselect
          v-model="selected_subjects"
          :options="subjects"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Subjects"
          label="name"
          track-by="id"
          :limit="1"
          :preselect-first="true"
          @input="filters"
          style="max-width: 100%;"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
              class="multiselect__single"
              v-if="selected_subjects.length &amp;&amp; !isOpen"
            >
              {{ selected_subjects.length }} options selected
            </span>
          </template>
        </multiselect>
      </div>
      <div :class="[hasAdminAdminPermission ? 'col-xs-2' : 'col-xs-3']">
        <pl-select
          :options="teachers"
          :selected="selected_userType"
          :disabled="show_trial_teachers"
          :arrow="true"
          placeholder="All users"
          style="padding: 0px;"
          class="dialog-role-select"
          @change="filterUsersByType($event)"
        >
        </pl-select>
      </div>
      <div :class="[hasAdminAdminPermission ? 'col-xs-2' : 'col-xs-3']">
        <multiselect
          v-model="selected_schools"
          :options="schools"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Schools"
          label="name"
          track-by="id"
          :preselect-first="true"
          @input="filters"
          style="max-width: 100%;"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
              class="multiselect__single"
              v-if="selected_schools.length &amp;&amp; !isOpen"
            >
              {{ selected_schools.length }} schools selected
            </span>
          </template>
        </multiselect>
      </div>
      <div class="trial-teachers col-xs-2" v-if="hasAdminAdminPermission">
        <pl-select
          :options="accountType"
          :selected="selected_accountType"
          :disabled="show_trial_teachers"
          :arrow="true"
          placeholder="All"
          style="padding: 0px;"
          class="dialog-role-select"
          @change="filterUsersByAccountType($event)"
        >
        </pl-select>
      </div>
      <div class="col-xs-2">
        <div class="flex items-center border border-solid w-full border-gray-200 bg-gray-100 rounded">
          <div class="flex justify-center items-center px-3">
            <i class="fa-solid text-center fa-at"></i>
          </div>
          <input class="w-100 outline-none border-none pr-4 pl-1 py-2" v-model="email_domain" placeholder="Search by email suffix" @keyup.enter="filters" />
        </div>
        <!-- <pl-input
          class="w-100"
          v-model="email_domain"
          placeholder="Search by email suffix"
          @keyup.enter="filters"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import adminServices from 'services/admin/adminServices';
  export default {
    components: {
      Multiselect,
    },
    computed: {
      ...mapGetters(['hasAdminAdminPermission']),
    },
    data() {
      return {
        user_search: '',
        email_search: '',
        subjects: [],
        show_trial_teachers: false,
        selected_subjects: [],
        get_trial_teachers: false,
        teachers: ['All', 'Teacher', 'Student'],
        selected_userType: 'Teacher',
        schools: [],
        selected_schools: [],
        accountType: ['All', 'Free', 'Paid'],
        selected_accountType: 'All',
        email_domain: ''
      };
    },
    methods: {
      filters() {
        const filters = {
          name: this.user_search,
          email: this.email_search,
          subjects_ids: this.selected_subjects.map((subject) => subject.id),
          roles: this.selected_userType.toLowerCase(),
          schools_ids: this.selected_schools.map((school) => school.id),
          types: this.selected_accountType.toLowerCase(),
          email_domain: this.email_domain,
        };
        this.$emit('parlay-users-filter-changed');
        this.$emit('filters', filters);
      },
      filterUsersByType(event) {
        this.selected_userType = event.toLowerCase();
        const filters = {
          name: this.user_search,
          email: this.email_search,
          subjects_ids: this.selected_subjects.map((subject) => subject.id),
          roles: this.selected_userType,
          schools_ids: this.selected_schools.map((school) => school.id),
          types: this.selected_accountType.toLowerCase(),
        };
        this.$emit('parlay-users-filter-changed');
        this.$emit('filters', filters);
      },
      filterUsersByAccountType(event) {
        this.selected_accountType = event.toLowerCase();
        const filters = {
          name: this.user_search,
          email: this.email_search,
          subjects_ids: this.selected_subjects.map((subject) => subject.id),
          roles: this.selected_userType.toLowerCase(),
          schools_ids: this.selected_schools.map((school) => school.id),
          types: this.selected_accountType,
        };
        this.$emit('parlay-users-filter-changed');
        this.$emit('filters', filters);
      },
      getAllSchools(query = null) {
        adminServices
          .getAllSchools(query)
          .then((res) => {
            this.schools = res.data;
          })
          .catch(console.log);
      },
    },
    mounted() {
      this.$store
        .dispatch('getAllSubjects')
        .then((results) => (this.subjects = results));

      this.getAllSchools();
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .permissions-work-style{
    color: #78BEC8
  }

  .trial-teachers{
    display: flex !important
    align-items: center
    justify-content: center
  }
  .trial-div
    color:#5FA95C
  .dialog-role-select{
    height: 40px;
    border: 2px solid #e1e8ee;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect {
    .multiselect__content-wrapper {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// adminViewUsersFilters.vue?2a109a63